// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:767px){.mask[data-v-0c7dad9c]{-webkit-mask-image:linear-gradient(#000,#fff);mask-image:linear-gradient (#000,#fff)}}.custom-transition-timing[data-v-0c7dad9c]{transition-timing-function:cubic-bezier(.39,-.03,.26,1.33)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
